import { useState } from "react";

/**
 * Runs `onChange` during render when any of `deps` changes (compared with `Object.is`, as effect
 * deps are). Unlike an effect it never runs on mount, and the adjusted state is in place before
 * the browser paints rather than one frame later.
 *
 * `onChange` runs while rendering, so it may only call this component's own state setters, never
 * a parent's callback.
 */
export default function useOnDepsChange(
  deps: readonly unknown[],
  onChange: () => void
) {
  const [seen, setSeen] = useState(deps);
  const changed =
    deps.length !== seen.length ||
    deps.some((dep, index) => !Object.is(dep, seen[index]));
  if (changed) {
    setSeen(deps);
    onChange();
  }
}
